<!-- Contenedor APP -->
<div class="container-fluid app-endoso py-4">
  <mat-card>
    <mat-card-content>
      <div class="capaloader" *ngIf="loadingService"></div>
      <div class="row title">
        <div class="col-12">
          <h3 class="feature-title-endosos">SOLICITUD DE RESCATE</h3>
        </div>
      </div>
      <mat-divider [inset]="true"></mat-divider>
      <div class="row text-center title-margin">
        <div class="vPolizaText" style="padding-top: 25px;">
          TU VALOR PÓLIZA A LA FECHA:
          <p class="orangeTextMoney">$&nbsp;</p>
          {{ separadorDeMiles(montoPesos) }}
        </div>
        <!-- Radio Buttons Selección Tipo Rescate -->
        <div class="row type-rescue-select py-2">
          <mat-radio-group
            [(ngModel)]="tipoRescate"
            (change)="onSelectionChange()"
            labelPosition="after"
            class="radio-group-container"
          >
            <mat-radio-button
              class="radio-button-ib col-md-6"
              [color]="'primary'"
              value="parcial"
              checked
              >Rescate parcial
            </mat-radio-button>
            <mat-radio-button
              class="radio-button-ib col-md-6"
              [color]="'primary'"
              value="completo"
              >Rescate total y anulación de póliza
            </mat-radio-button>
          </mat-radio-group>
        </div>

        <!-- Radio Buttons Selección Tipo Rescate FIN -->
      </div>
      <div *ngIf="tipoRescate === 'parcial'">
        <div class="row text-center">
          <div class="col-12 py-3">
            Ingresa el monto de tu
            <strong
              >valor póliza
              <svg-icon
                class="icon"
                app-tooltip="Ahorro acumulado en tu póliza."
                position="bottom"
                src="../../../../../assets/icons/information-right.svg"
                [svgStyle]="{
                  'width.rem': 0.93,
                  'height.rem': 0.87,
                  position: 'relative',
                  'left.rem': 0.15
                }"
              ></svg-icon
            ></strong>
            que deseas rescatar.
          </div>
          <div class="row">
            <div class="right custom-input-text dsp-ib py-2 col-12 col-md-6">
              <mat-form-field
                class="container-form-field col-12 col-md-6"
                [ngStyle]="{ 'max-width': width }"
                appearance="outline"
              >
                <span matPrefix>$&nbsp;</span>
                <input
                  matInput
                  id="valor"
                  type="text"
                  name="valorRescatado"
                  [(ngModel)]="valorRescatado"
                  [maxlength]="9"
                  (keyup)="transformValue()"
                  (keypress)="numberOnly($event)"
                  (focusout)="onLostFocus('montoPesos')"
                  (focus)="onFocus('montoPesos')"
                />
              </mat-form-field>
              <span
                *ngIf="montoPesosValido === false"
                class="text-danger animated fadeIn "
                style="display: block !important;width: 350px;"
                >El monto ingresado no debe ser superior al 85% del Valor
                Póliza.</span
              >
              <span
                *ngIf="valorRescatado <= 0 && valorRescatado"
                class="text-danger animated fadeIn "
                style="display: block !important; width: 350px;"
                >El monto ingresado debe ser mayor a 0</span
              >
              <span
                *ngIf="montoPesosVacioValido === false"
                class="text-danger animated fadeIn "
                style="display: block !important; width: 350px;"
                >Debe ingresar un monto válido</span
              >
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="tipoRescate === 'parcial'">
        <div class="col-12 py-3 descripcion">
          <div *ngIf="tipo === 'APV'" class="vPolizaText">
            VALOR PÓLIZA:
            <p class="orangeTextMoney">$&nbsp;</p>
            {{ separadorDeMiles(montoPesos) }}
          </div>
          <br />
          El monto máximo permitido para realizar un rescate parcial corresponde
          al 85% del
          <strong
            >valor póliza.
            <svg-icon
              class="icon"
              app-tooltip="Ahorro acumulado en tu póliza."
              position="bottom"
              src="../../../../../assets/icons/information-right.svg"
              [svgStyle]="{
                'width.rem': 0.93,
                'height.rem': 0.87,
                position: 'relative',
                'left.rem': 0.15
              }"
            ></svg-icon
          ></strong>
          <br />
          Tu solicitud está sujeta a confirmación, pues depende de las
          transacciones que pudieran estar ejecutándose (valorización de valores
          cuotas, transferencia entre fondos mutuos, cargos sobre póliza).
          <br />
          <div *ngIf="tipo === 'APV'">
            Debes considerar que tendrás descuentos legales asociado al régimen
            tributario de tus aportes. En la pestaña “Resumen” o en tu Cartola
            verás el
            <b>régimen tributario</b>
            al que acogiste tu APV.
          </div>
        </div>
      </div>
      <br />
      <!-- Mensaje Informativo -->
      <mat-accordion *ngIf="tipo === 'APV'">
        <app-colapsable [title]="'REGIMEN TRIBUTARIO A'" [expanded]="false">
          <div description class="colapsable-panel-description"></div>
          <div body class="textarea">
            <p>
              Si retiras tus depósitos APV hechos en Régimen A, perderás el
              beneficio tributario del 15% sobre este monto retirado. Además, la
              rentabilidad ganada sobre el monto rescatado deberá pagar el
              impuesto Único de 2da categoría o Global Complementario porque se
              considera una renta, un ingreso.
            </p>
          </div>
        </app-colapsable>
        <app-colapsable [title]="'REGIMEN TRIBUTARIO B'" [expanded]="false">
          <div description class="colapsable-panel-description"></div>
          <div body class="textarea">
            <p>
              Los retiros de tus depósitos APV hechos en Régimen B se consideran
              como una renta tributable (dado que no lo fueron en el momento en
              que se hizo el aporte de APV) y pagarán el impuesto a la renta
              correspondiente. Además, este retiro paga un impuesto único en tu
              declaración anual de impuestos, con una tasa aumentada en al menos
              un 4%, de la tasa del impuesto global complementario al que quedes
              afecto en ese mismo año.
            </p>
          </div>
        </app-colapsable>
      </mat-accordion>
      <br />
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-content>
      <div class="row py-2">
        <div class="col-12">
          <div class="row title">
            <div class="col-12">
              <h3 class="feature-title-endosos">FORMA DE PAGO</h3>
            </div>
          </div>
          <div class="row py-2">
            <div class="col-12">
              <div class="descripcion-page-endosos">
                <p class="descripcion-page-endosos-margen">
                  Ingresa tus datos bancarios para realizar el pago del rescate.
                </p>
                <p>
                  Recuerda que el titular de la cuenta debe ser siempre el
                  contratante.
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- Radio Buttons Selección Tipo Rescate -->
        <div class="row type-rescue-select py-2">
          <mat-radio-group
            [(ngModel)]="tipoDeposito"
            (change)="depositoSelectionChange()"
            labelPosition="after"
            class="radio-group-container"
          >
            <mat-radio-button
              [color]="'primary'"
              value="dbancario"
              class="radio-button-ib col-md-6"
              checked
              >Depósito Bancario
            </mat-radio-button>
            <mat-radio-button
              [color]="'primary'"
              class="radio-button-ib col-md-6"
              value="valeVista"
              >Vale Vista electrónico
            </mat-radio-button>
          </mat-radio-group>
        </div>
        <!-- Radio Buttons Selección Tipo Rescate FIN -->
      </div>
      <app-mini-loader *ngIf="loading"></app-mini-loader>
      <app-error *ngIf="error"></app-error>
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div *ngIf="!loading && !error">
          <div class="row">
            <div class="form-group col-md-6">
              <div class="pd-lr-15">
                <app-form-select
                  [label]="'Banco'"
                  formControlName="banco"
                  [options]="bancos"
                  [optionValue]="'CodigoBanco'"
                  [optionDescription]="'NombreBanco'"
                  [messageError]="
                    !form.get('banco').value && pierdeFocoBancos
                      ? 'Ingrese un numero de cuenta válido.'
                      : getErrorMessage(form, 'banco')
                  "
                  [disabled]="tipoDeposito != 'dbancario'"
                  [placeholder]="'Seleccionar...'"
                  ($onChange)="bancoOnchange($event)"
                  [required]="tipoDeposito === 'dbancario'"
                  (lostFocus)="onLostFocus('banco')"
                >
                </app-form-select>
              </div>
            </div>
            <div class="form-group col-md-6">
              <div class="pd-lr-15">
                <app-form-select
                  [label]="'Tipo de Cuenta'"
                  formControlName="cuentas"
                  [options]="tiposCuentas"
                  [optionValue]="'Valor'"
                  [optionDescription]="'Nombre'"
                  [disabled]="tipoDeposito != 'dbancario'"
                  [messageError]="
                    !form.get('cuentas').value && pierdeFocoCuentas
                      ? 'Ingrese un numero de cuenta válido.'
                      : getErrorMessage(form, 'cuentas')
                  "
                  [placeholder]="'Seleccionar...'"
                  [required]="tipoDeposito === 'dbancario'"
                  (lostFocus)="onLostFocus('cuentas')"
                >
                </app-form-select>
              </div>
            </div>
            <div class="form-group col-md-6">
              <div class="container-account-number">
                <div class="pd-lr-15">
                  <app-form-input-text
                    [label]="'Número de cuenta'"
                    [maxlength]="20"
                    [disabled]="tipoDeposito != 'dbancario'"
                    [placeholder]="'Ej: 31245645689'"
                    formControlName="nCuentaDeposito"
                    [messageError]="
                      !form.get('nCuentaDeposito').value &&
                      pierdeFocoNCuenta &&
                      tipoDeposito === 'dbancario'
                        ? 'Ingrese un numero de cuenta válido.'
                        : getErrorMessage(form, 'nCuentaDeposito')
                    "
                    (lostFocus)="onLostFocus('nCuentaDeposito')"
                    (keypress)="numberOnly($event)"
                    [required]="tipoDeposito === 'dbancario'"
                    autocomplete="off"
                  >
                  </app-form-input-text>
                </div>
              </div>
            </div>
            <div class="form-group col-md-6">
              <div class="pd-lr-15">
                <app-form-input-text
                  [label]="'RUT'"
                  [placeholder]="'Ej: 12.345.678-9'"
                  [maxlength]="12"
                  formControlName="rutContratante"
                  [disabled]="true"
                  required
                  autocomplete="off"
                >
                </app-form-input-text>
              </div>
            </div>
            <div class="form-group col-md-6">
              <div class="pd-lr-15">
                <app-form-input-text
                  [label]="'Nombre y apellido'"
                  [placeholder]="'Ej: Juan Pérez'"
                  formControlName="nombreContratante"
                  [disabled]="true"
                  required
                  autocomplete="off"
                >
                </app-form-input-text>
              </div>
            </div>
            <div class="form-group col-md-6">
              <div class="pd-lr-15 positionRelative ">
                <app-form-input-text
                  [label]="'Correo electrónico'"
                  [placeholder]="'Ej: juanperez@gmail.com'"
                  formControlName="emailDeposito"
                  (lostFocus)="onLostFocus('emailDeposito')"
                  [disabled]="true"
                  autocomplete="off"
                ></app-form-input-text>
                <svg-icon
                  *ngIf="mostrarInfo"
                  class="icon svgEmail"
                  app-tooltip="{{ info }}"
                  position="right"
                  src="../../assets/icons/information-right-white.svg"
                  [svgStyle]="{
                    'width.rem': 0.93,
                    'height.rem': 0.87,
                    position: 'relative',
                    'left.rem': 0.15
                  }"
                ></svg-icon>
              </div>
            </div>
            <div class="form-group col-md-6">
              <div class="pd-lr-15">
                <app-form-input-text
                  [label]="'Teléfono de contacto'"
                  [placeholder]="'Ej: 912345678'"
                  formControlName="telDeposito"
                  [prefix]="'+56'"
                  [maxlength]="9"
                  [messageError]="
                    !form.get('telDeposito').value && pierdeFocoTelefono
                      ? 'Ingrese un teléfono válido.'
                      : getErrorMessage(form, 'telDeposito')
                  "
                  (lostFocus)="onLostFocus('telDeposito')"
                  (keypress)="numberOnly($event)"
                  required
                  autocomplete="off"
                >
                </app-form-input-text>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="tipoRescate != 'parcial'">
          <div class="row">
            <div class="col-12 py-3">
              <p class="description-page-endosos">
                <mat-checkbox
                  formControlName="terminos"
                  [required]="tipoRescate != 'parcial'"
                  (change)="TerminosModificados()"
                ></mat-checkbox>

                <strong style="padding-left: 15px;">
                  Declaro estar en conocimiento que al realizar un rescate
                  total, se pondrá fin a mi póliza de seguro, perdiendo todas
                  mis coberturas contratadas y por lo tanto:
                </strong>
              </p>
              <p class="description-page-endosos">
                <strong>1. </strong>
                En caso de tener cobertura de fallecimiento y/o muerte
                accidental; mis beneficiarios no recibirán indemnización.
              </p>
              <p class="description-page-endosos">
                <strong>2. </strong>
                En caso de tener cobertura adicional de salud con asegurados
                dependientes, tanto ellos como yo dejaremos de estar protegidos.
              </p>
              <p class="description-page-endosos">
                <strong>3. </strong>
                Si contrato un nuevo seguro en Vida Security o en otra compañía,
                nuevamente deberá ser evaluado mi estado de salud, lo que puede
                provocar: ser rechazado o sobreprimado.
              </p>
              <p class="description-page-endosos">
                <strong>4. </strong>
                Si contrato un nuevo seguro en otra compañía, tendré que pagar
                las primas en base a mi edad actual, la cual es mayor a la que
                tenía al contratar el seguro en Vida Security. Además deberé
                pagar nuevamente los costos administrativos que generalmente se
                pagan durante los primeros años de vigencia.
              </p>
            </div>
          </div>
        </div>
        <mat-divider [inset]="true"></mat-divider>
        <div class="row py-2">
          <app-mini-loader *ngIf="loadingService"></app-mini-loader>
          <app-empty-data-message
            *ngIf="formularioSinProblemas"
            message="Su solicitud ha sido registrada con éxito."
          >
          </app-empty-data-message>
        </div>
        <div class="row py-2">
          <div class="col-sm-12 text-center">
            <button
              mat-flat-button
              type="button"
              class="btn btn-gray"
              (click)="limpiarFormulario()"
            >
              Cancelar
            </button>
            <button
              mat-flat-button
              color="primary"
              type="submit"
              [disabled]="
                !form.valid ||
                !form.dirty ||
                (tipoRescate === 'parcial' && valorRescatado === 0) ||
                (tipoRescate === 'parcial' && valorRescatado.trim() === '') ||
                (tipoRescate === 'parcial' && valorRescatado === null) ||
                (tipoRescate === 'parcial' && montoPesosValido === false)
              "
              class="btn"
            >
              Solicitar
            </button>
          </div>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
<!-- Contenedor APP FIN -->
